import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { formatDataToRadioGraph } from 'helpers/GraphHelpers';
import RadarGraphFull from 'components/StatisticalGraphs/containers/RadarGraphFull';

const RadarGraphInfoProduct = ( {
  gId = 1,
  graphHeight = '315px',
  title = 'LAPTOPSalesByBrandU',
  hoverTitle,
  dataKey = 'unitSales',
  children,
  infoProductData,
  loading,
  error,
  locale,
} ) => {
  const [dataToGraph, setDataToGraph] = useState( {} );

  useEffect( () => {
    const formatData = formatDataToRadioGraph( infoProductData, dataKey );
    if ( JSON.stringify( dataToGraph ) !== JSON.stringify( formatData ) ) {
      setDataToGraph( formatData );
    }
  }, [locale.locale, infoProductData, dataKey, dataToGraph] );

  return (
    <RadarGraphFull
      {...{
        title,
        loading,
        error,
        hoverTitle,
        children,
      }}
      height={graphHeight}
      htmlId={`line_chart_market_product_${gId}`}
      data={dataToGraph.data}
      seriesData={dataToGraph.seriesData}
    />
  );
};

const mapStateToProps = ( { products, settings }, { categoryId } ) => {
  if ( !categoryId ) {
    return {
      infoProductData: undefined,
      loading: true,
      error: null,
      locale: settings.locale,
    };
  }
  const product = products.infoProducts.byCategoryId[categoryId];
  if ( !product ) {
    return {
      infoProductData: undefined,
      loading: false,
      error: null,
      locale: settings.locale,
    };
  }
  return {
    infoProductData: product.data && product.data.data,
    loading: product.loading,
    error: product.error,
    locale: settings.locale,
    // activeSessionId: user && user.activeSession && user.activeSession.id,
  };
};

export default connect( mapStateToProps )( injectIntl( RadarGraphInfoProduct ) );
